import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import { Layout } from 'antd';
import ScrollToTopOnMount from '../scroll_to_top_on_mount/ScrollToTopOnMount';
import SubnavTabs from '../subnav_tabs/SubnavTabs';
import RouteWithSubRoutes from '../route_with_sub_routes/RouteWithSubRoutes';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { withUserType } from '../withUserType';

const { Content } = Layout;

require('./SiteSurveysOverviewPage.less');

const SiteSurveysPage: FC<any> = ({
	history,
	companyConfig,
	userType,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/siteSurveys/overview/${key}`),
		[]
	);

	const checkTabActive = useCallback((key) => {
		const pathname = history.location.pathname;
		return pathname.indexOf(key) !== -1;
	}, []);

	const tabs = [
		{
			key: 'all',
			name: 'All',
		},
		{
			key: 'walkthroughs',
			name: 'Walkthroughs',
		},
		{
			key: 'templates/overview',
			name: 'Templates',
		},
	];

	return (
		<div>
			<ScrollToTopOnMount />

			<div>
				<Route
					path={`/${userType}/siteSurveys/overview`}
					exact={true}
					render={(props) => (
						<Redirect
							to={{
								pathname: `/${userType}/siteSurveys/overview/all`,
							}}
						/>
					)}
				/>
				<Content className="siteSurveysPage" style={{ padding: '0 0.5em' }}>
					{/*<ScrollToTopOnMount/>*/}
					{/*<BackTop/>*/}

					<div
						style={{
							margin: '0 -8px',
							padding: '24px',
							paddingBottom: 0,
							background: nullSafeGet('detail.config.theme.navblock', companyConfig),
							marginBottom: 8,
						}}
					>
						<h4
							style={{
								color: 'rgba(255, 255, 255, 0.9)',
								marginRight: 8,
								marginBottom: 24,
							}}
						>
							Site Surveys
						</h4>
						<SubnavTabs tabs={tabs} onChange={handleTabChange} isActive={checkTabActive} />
					</div>
					{childRoutes.map((r, i) => (
						<RouteWithSubRoutes key={i} {...r} />
					))}
				</Content>
			</div>
		</div>
	);
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config,

	currentUser: state.session.currentUser,
});

export default withUserType(
	withRouter<any, any>(connect(mapStateToProps)(SiteSurveysPage as any)) as any
);
